// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"233":"ca5a8385","941":"6e1b7782"}[chunkId] + ".chunk.css";
};